/** =========================================================
 * Customers controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-customers')
    .controller('CustomersController', CustomersController);

  CustomersController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function CustomersController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page customers',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'customer',
        getDataParams: {
          order: {
            id: 'desc'
          },
          count: ['projects', 'customer_employees']
        },
        filters: angular.copy($stateParams.filters),
        lists: {
          types: ['public', 'private']
        },
        fields: [{
          title: 'Name',
          key: 'name',
          order: true
        }, {
          title: 'Phone',
          key: 'phone',
          order: true
        }, {
          title: 'Email',
          key: 'email',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-customer.html',
          wide: true
        },
        edit: {
          template: 'app/views/dialogs/item-customer.html',
          wide: true,
          except: ['projects_count', 'customer_employees_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Projects',
          icon: 'icon-folder-alt',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('Customer') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['customer_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projects_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }, {
          title: 'Customer employees',
          icon: 'icon-people',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('customer_employee view'),
          action: function (item) {
            try {
              $state.go('app.page-customer-employees', {
                filters: [{
                  name: $translate.instant('Customer') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['customer_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.customer_employees_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
